import { Injectable } from '@angular/core';
import { VisibaApiHttp } from '../Classes/visibaHttp.class';
import { SpaContext } from '../Classes/spacontext';

@Injectable()
export class CiscoMeetingServerService {
	private baseUri: string = null;

	constructor(private http: VisibaApiHttp, public _spaContext: SpaContext) {
		this.baseUri = `/Api/Office/${this._spaContext.unitConfig.LicenceHolder.Id}/units/${this._spaContext.unitConfig.Unit.UnitId}/CiscoMeetingServer`;
	}

	addParticipant(callTicket: Guid, sipAddress: string) {
		return this.http.post(this.baseUri + callTicket + '/Participants', { SipAddress: sipAddress });
	}
}
